import { COOKIE_SESSION_ID } from '@config/constants'

import { getCorrelationId, refreshCorrelationIdCookie } from './helpers'

export const refreshSessionIdCookie = (cookies, res) => {
  const sessionId = getCorrelationId(cookies, COOKIE_SESSION_ID)

  return refreshCorrelationIdCookie(COOKIE_SESSION_ID, sessionId, res)
}
